var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.number !== null)?_c('span',{class:_vm.cssClass},[(!_vm.print)?_c('span',[_vm._v(_vm._s(_vm.percentage ? "%" : "")+_vm._s(_vm.stringValue)+_vm._s(_vm.price ? "₺" : ""))]):_c('span',[_vm._v(_vm._s(_vm.value))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }